import PaymentMethods from "../components/pages/billing/PaymentMethodsPage";
import BillingInvoicesPage from "../components/pages/billing/BillingInvoicesPage";
import BillingPage from "../components/pages/billing/BillingPage";

const routes = [
    {
        path: "/billing",
        element: <BillingPage />
    },
    {
        path: "/billing/invoices",
        element: <BillingInvoicesPage />
    },
    {
        path: "/billing/methods",
        element: <PaymentMethods />
    }
];

export default routes;
